export { default } from './part-faq-about-us';
